/**
 * Calendar page
 */
function irCalendarPage() {
	if (!document.querySelector('main.subpage.ir-page.calendar')) return;

	/*** @type NodeListOf<HTMLButtonElement> */
	const saveInOutlookButtons = document.querySelectorAll('[data-action="save-in-outlook"]');
	for (const button of saveInOutlookButtons) {
		button.addEventListener('click', () => {
			const eventContainerElement = button.closest('.event');
			if (!eventContainerElement) return;

			const title = eventContainerElement.dataset.eventName;
			const startDate = eventContainerElement.dataset.eventStart;
			const endDate = eventContainerElement.dataset.eventEnd;
			const startHour = eventContainerElement.dataset.eventHour;
			const location = eventContainerElement.dataset.eventLocation || "Brak lokalizacji";

			let beginDate, endDateValue;

			if (startHour) {
				const [day, month, year] = startDate.split('/');
				beginDate = `${year}/${month}/${day} ${startHour}`;

				if (endDate) {
					const [endDay, endMonth, endYear] = endDate.split('/');
					endDateValue = `${endYear}/${endMonth}/${endDay} ${startHour}`;
				} else {
					endDateValue = beginDate;
				}
			} else {
				const [day, month, year] = startDate.split('/');
				beginDate = `${year}/${month}/${day}`;

				if (endDate) {
					const [endDay, endMonth, endYear] = endDate.split('/');
					endDateValue = `${endYear}/${endMonth}/${endDay}`;
				} else {
					endDateValue = dayjs(beginDate).add(1, 'days').format('YYYY/MM/DD');
				}
			}

			const cal = ics();
			cal.addEvent(
				title,
				'',
				location,
				beginDate,
				endDateValue
			);
			cal.download('calevent');
		});
	}

	document.querySelectorAll('.event-save-in-gcal').forEach(button => {
		button.addEventListener('click', function () {
			const eventElement = this.closest('.event');
			const title = eventElement.dataset.eventName;
			const startDate = eventElement.dataset.eventStart;
			const endDate = eventElement.dataset.eventEnd;
			const startHour = eventElement.dataset.eventHour;
			const location = eventElement.dataset.eventLocation || "Brak lokalizacji";

			function formatDate(dateStr, timeStr = null, addOneDay = false) {
				const [day, month, year] = dateStr.split('/');
				let date = new Date(`${year}-${month}-${day}${timeStr ? `T${timeStr}:00` : ''}`);

				if (addOneDay) {
					date.setDate(date.getDate() + 1);
				}

				if (timeStr) {
					const utcDate = new Date(date.toLocaleString("en-US", { timeZone: "Europe/Warsaw" }));
					return utcDate.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
				} else {
					return date.toISOString().slice(0, 10).replace(/-/g, '');
				}
			}

			const isAllDay = !startHour;
			const formattedStart = formatDate(startDate, isAllDay ? null : startHour);
			let formattedEnd = endDate
				? formatDate(endDate, isAllDay ? null : startHour, isAllDay)
				: formattedStart;

			const calendarUrl = new URL('https://calendar.google.com/calendar/render');
			calendarUrl.searchParams.set('action', 'TEMPLATE');
			calendarUrl.searchParams.set('text', title);
			calendarUrl.searchParams.set('location', location);
			calendarUrl.searchParams.set('dates', `${formattedStart}/${formattedEnd}`);

			window.open(calendarUrl.toString(), '_blank');
		});
	});

	const select = document.getElementById('events-years-filter');
	const events = document.querySelectorAll('.event');

	function filterEvents(year) {
		events.forEach(event => {
			const eventYear = event.dataset.year;
			event.style.display = (eventYear == year) ? '' : 'none';
		});
	}

	const urlParams = new URLSearchParams(window.location.search);
	const yearFromUrl = urlParams.get('rok');

	if (yearFromUrl) {
		select.value = yearFromUrl;
		filterEvents(yearFromUrl);
	} else {
		filterEvents(select.value);
	}

	select.addEventListener('change', function () {
		const selectedYear = this.value;

		filterEvents(selectedYear);

		const newUrl = new URL(window.location.href);
		newUrl.searchParams.set('rok', selectedYear);
		window.history.replaceState({}, '', newUrl);
	});

}
